module.exports = __webpack_public_path__ + "img/121.87a03473.jpg";